import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { formatPriceDecimals } from 'utils/format'
import moment from 'moment'
import styles from '../setupform-page/setupform-page.css'

const DATE_FORMAT = 'ddd D MMMM LT'

class VoucherRow extends Component {
  constructor(props) {
    super(props)
    this.onEditClick = () => this.props.onEditClick(props.setupformId, props.voucher.instanceGroupId)
    this.onCopyClick = () => this.props.onCopyClick(props.setupformId, props.voucher.instanceGroupId)
    this.onDeleteClick = () => confirm( // eslint-disable-line no-alert
        "Are you sure that you want to delete this voucher?"
      ) && this.props.onDeleteClick(props.setupformId, props.voucher.instanceGroupId)
  }
  render() {
    const { voucher, currencyCode } = this.props
    return (
      <tr>
        <td>{voucher.voucherName}</td>
        <td styleName="centered">
          {moment(voucher.voucherValidFrom).local().format(DATE_FORMAT)}<br />
          to<br />
          {moment(voucher.voucherValidTo).local().format(DATE_FORMAT)}
        </td>
        <td styleName="centered">
          {moment(voucher.onsaleTime).local().format(DATE_FORMAT)}<br />
          to<br />
          {moment(voucher.offsaleTime).local().format(DATE_FORMAT)}
        </td>
        <td>{voucher.voucherQuantity}</td>
        <td>
          {voucher.initialPrice !== voucher.discountPrice &&
            <span>
              <strike styleName="initial-price">
                {formatPriceDecimals(voucher.initialPrice, currencyCode)}
              </strike>/
            </span>
          }
          {formatPriceDecimals(voucher.discountPrice, currencyCode)}
          <br />
          <span styleName="commission">{+(voucher.commission)}% commission</span>
        </td>
        <td styleName="table-button-container">
          <button onClick={this.onEditClick} styleName="form-button">
            Edit
          </button>
          {" "}
          <button onClick={this.onCopyClick} styleName="form-button">
            Copy
          </button>
          <br />
          <button onClick={this.onDeleteClick} styleName="form-button">
            Delete
          </button>
        </td>
      </tr>
    )
  }
}

VoucherRow.propTypes = {
  voucher: PropTypes.object,
  setupformId: PropTypes.string,
  onEditClick: PropTypes.func,
  onCopyClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  currencyCode: PropTypes.string,
}

export default CSSModules(VoucherRow, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/setupform-vouchers-page/voucher-row.js
 **/